module.exports = __webpack_public_path__ + "img/cached-logo-white-text.e32fd5fd.svg";